import { takeEvery, call, put } from 'redux-saga/effects';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import * as privacyPolicyActions from 'redux/ducks/privacyPolicy/privacyPolicyDucks';

export function* getPolicyVersionZone({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getPolicyVersionZone, payload);
    yield put(privacyPolicyActions.getPolicyVersionZoneSuccess(response));
  } catch (error) {
    yield put(privacyPolicyActions.getPolicyVersionZoneFail(error.errorCode));
  }
}

export function* getTermsCn({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getTermsCn, payload);
    yield put(privacyPolicyActions.getTermsCnSuccess(response));
  } catch (error) {
    yield put(privacyPolicyActions.getTermsCnFail(error.errorCode));
  }
}

export default function* privacyPolicySaga() {
  yield takeEvery(privacyPolicyActions.getPolicyVersionZone, getPolicyVersionZone);
  yield takeEvery(privacyPolicyActions.getTermsCn, getTermsCn);
}
